import {Avatar} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {PiCertificate} from 'react-icons/pi'
import {getResponseItem, renderIf, renderIfElse} from '../../../../Shared'
import {IdentifierTypes} from '../../../appFieldTypes'
import {HeaderWithIconLine} from '../../../Templates/items/ListHeader'
import getAvatar from "../../../../../helpers/getAvatar";
import getTitle from "../../../../../helpers/getTitle";
import ImageLoader from "../../../../../components/ImageLoader";
import {NoImage, Photo} from "../../../../../conts/imageBase64";
import getLabelOfGender from "../../../../../helpers/getLabelOfGender";
import {DoubleValueItem} from "../../../CatholicHousehold/components/CatholicHouseholdComponents";
import {ItemInformation} from "../../../Organization/OrganizationEntity";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../../helpers/getLinkToDetail";
import {FaLink, FaUserGraduate} from "react-icons/fa6";
import {bindQueryParam} from "../../../functions/routerHelper";
import useAsync from "../../../../../modules/asyncCache/useAsync";
import {course_getStudentById_Api} from "../../../../../apis";
import {getId} from "../../../../../apis/model/base";
import {BsInfoCircleFill} from "react-icons/bs";
import getAliasName from "../../../../../helpers/getAliasName";
import {MdContactPhone} from "react-icons/md";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import {convertStringToDate} from "../../../../../helpers/dateUtils";
import {formatDate} from "../../../../../helpers/datetimeHelpers";

export const StudentInformationFull = ({student, medal_awards = []}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const apiInfo = course_getStudentById_Api

    const id = getId(student) || student

    const {response, isLoading = false} = useAsync({
        apiInfo,
        query: bindQueryParam({id}),
    })

    const item = getResponseItem(response)

    const {
        avatar,
        notes,
        edit,
        user,
        student_idcode,
        identifier_code,
        identifier_type,
        place_of_birth,
        patron_saint,
        patron_saint_name,
        fullname,
        contact_address,
        gender, date_of_birth,
        contact_phone,
        contact_email,
        religious_order,
        religious_order_name,
        parish,
        parish_name,
        diocese,
        diocese_name,
    } = item ?? {}

    const typeIdentify = _.find(IdentifierTypes, {value: identifier_type})?.label

    return (
        <div className="flex flex-col gap-5">
            <div className="flex flex-col gap-2">
                <HeaderWithIconLine
                    icon={<BsInfoCircleFill size={14} className="text-color-500 mr-1"/>}
                    title="student information"
                    className="text-sm text-color-400"
                />
                <div className="flex gap-3">
                    <ImageLoader
                        style={{width: isSm ? 100 : 130, height: isSm ? 100 : 130}}
                        src={avatar || NoImage}
                        fallback={NoImage}
                        className="background-200 rounded-lg object-cover mt-1"
                    />
                    <div className="flex flex-col flex-1 gap-1">
                        <ItemInformation
                            primary={true}
                            showIcon={true}
                            label={!isSm && "full name"}
                            value={`${getAliasName(item, 'patron_saint') || ''} ${fullname}`}
                            className="text-sm"
                        />
                        {renderIf(
                            edit === true && identifier_type,
                            <ItemInformation showIcon={true} className="text-xs italic" label={t(typeIdentify)}
                                             value={identifier_code}/>
                        )}
                        {renderIf(
                            gender !== 0,
                            <ItemInformation showIcon={true} label={!isSm && "gender"}
                                             value={t(getLabelOfGender(gender))} className="text-xs italic"/>
                        )}
                        {renderIf(
                            _.some([date_of_birth, place_of_birth]),
                            <DoubleValueItem
                                showIcon={true}
                                labelFirst={!isSm && "date of birth"}
                                valueFirst={date_of_birth ? convertStringToDate(date_of_birth).format('DD/MM/YYYY') : t('not update')}
                                labelSecond={place_of_birth ? ' - ' : ''}
                                valueSecond={place_of_birth}
                                className="text-xs italic"
                            />
                        )}
                        {renderIf(
                            notes,
                            <ItemInformation showIcon={true} className="text-xs" label="note" value={notes}/>
                        )}
                    </div>
                </div>
            </div>
            {renderIf(
                user,
                <div className="flex flex-col gap-1">
                    <span className="text-xs text-color-500 italic">
                      <FaLink size={10} className="mr-1 text-color-400"/>
                        {`${t('link account')} : `}
                    </span>
                    <div className="ml-2 flex items-center gap-3">
                        <Avatar
                            size={36}
                            src={getAvatar(user)}
                            icon={<FaUserGraduate size={18} className="text-color-500"/>}
                            className="flex flex-center background-200"
                        />
                        <div className="flex flex-col">
                            <span className="text-xs text-color-500 italic leading-tight">
                                {`${t('account name')} : `}
                            </span>
                            {renderIfElse(
                                edit === true,
                                <Link target="_blank" to={getLinkToDetail(user)}
                                      className="font-medium text-primary-700 no-underline leading-snug">
                                    {getAliasName(user, 'patron_saint')}
                                    {` ${getTitle(user)}`}
                                </Link>,
                                <span className="font-medium text-primary-700 leading-snug">
                                    {getAliasName(user, 'patron_saint')}
                                    {getTitle(user)}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <div className="flex flex-col gap-2">
                <HeaderWithIconLine
                    icon={<MdContactPhone size={14} className="text-color-500 mr-1"/>}
                    title="contact information"
                    className="text-sm text-color-400"
                />
                <div className="ml-0 md:ml-1 flex flex-col gap-1">
                    {renderIf(
                        _.some([parish_name, diocese_name]),
                        <DoubleValueItem
                            showIcon={true}
                            labelFirst="belong to parish"
                            valueFirst={parish_name}
                            labelSecond={diocese_name && " - " || ''}
                            valueSecond={diocese?.fullname}
                            className="text-xs italic"
                        />
                    )}
                    {renderIf(
                        religious_order_name,
                        <ItemInformation
                            showIcon={true}
                            label="belong to religious order"
                            value={
                                <Link to={getLinkToDetail(religious_order)} className="no-underline">
                                    {religious_order_name}
                                </Link>
                            }
                            className="text-xs italic"
                        />
                    )}
                    <ItemInformation showIcon={true} label="phone" value={contact_phone} className="text-xs"/>
                    <ItemInformation showIcon={true} label="email" value={contact_email} className="text-xs"/>
                    <ItemInformation showIcon={true} label="address" value={contact_address} className="text-xs"/>
                </div>
            </div>
            {renderIf(
                medal_awards?.length > 0,
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        renderTitle={() => (
                            <div className="flex items-center gap-2">
                                <BsInfoCircleFill size={14} className="text-color-500"/>
                                <span className="font-semibold text-sm text-color-300 uppercase tracking-wider">
                                    {t('certification awarded')}
                                </span>
                            </div>
                        )}
                    />
                    {medal_awards.map((e, i) => (
                        <div key={i} className="w-full flex items-center gap-x-3 border border-color-50 rounded-md">
                            {renderIfElse(
                                e?.medal?.avatar,
                                <ImageLoader
                                    style={{width: 80, height: 55}}
                                    src={e?.medal?.avatar}
                                    fallback={Photo}
                                    className="rounded-l-md object-cover"
                                />,
                                <div style={{width: 80, height: 55}}
                                     className="flex flex-center background-100 rounded-l-md">
                                    <PiCertificate size={40} style={{color: '#dddddd'}}/>
                                </div>
                            )}
                            <div className="flex flex-col flex-1 gap-1">
                      <span className="font-bold text-sm text-primary leading-tight">
                        {getTitle(e.medal)}
                      </span>
                                <span className="flex items-center gap-1 text-xs italic leading-tight">
                          <span className="text-color-500">{`${t('date of award')} : `}</span>
                          <span
                              className="font-bold text-color-100">{formatDate(e?.medal?.eff_date, 'DD/MM/YYYY')}</span>
                      </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
